<template>
<v-form v-model="valid" ref="form">
  <v-layout row wrap>
    <v-flex xs12
      v-for='field in displayFields'
      :key='field'
      v-bind="getWrapperAttrs(field)"
      class='pa-2' >
      <slot :name='field'  >
        <v-textarea
          v-if='fieldConfigs && fieldConfigs[field] && fieldConfigs[field].type === "vtextarea"'
          :outline='hasErrors(field)'
          :label="field.replace(/_/g, ' ')"
          :error-messages="getErrors(field)"
          v-model="data[field]"
          v-bind="fieldConfigs[field] || {}" >
        </v-textarea>
        <v-text-field v-else
          :outline='hasErrors(field)'
          :label="field.replace(/_/g, ' ')"
          :error-messages="getErrors(field)"
          v-model="data[field]"
          v-bind="fieldConfigs[field] || {}" >
        </v-text-field>
        <slot :name='`${field}-after`' ></slot>
      </slot>
    </v-flex>
  </v-layout>
</v-form>
</template>

<script>
export default {
  name: 'ObjectForm',
  props: {
    value: { type: Object, default: () => { return {} } },
    errors: { type: Object, default: () => { return {} } },
    fields: { type: Array },
    fieldConfigs: { type: Object, default: () => { return {} } },
    ignoredFields: { type: Array },
    touch: { type: Number, default: 0 }
  },
  data () {
    return {
      valid: false,
      data: {}
    }
  },
  mounted () {
    this.data = this.value || {}
    this.$emit('valid', this.valid)
  },
  computed: {
    displayFields () {
      let all = []
      if (this.data) {
        all = Object.keys(this.data)
        if (this.fields) {
          all = this.fields
          // all = this.fields.filter((field) => {
          //   return all.indexOf(field) !== -1
          // })
        }
        if (this.ignoredFields) {
          all = all.filter((field) => {
            return this.ignoredFields.indexOf(field) === -1
          })
        }
      } else {
        console.log('data is not', this.data)
      }
      return all
    }
  },
  methods: {
    hasErrors (field) {
      if (this.errors) {
        return field in this.errors
      }
      return false
    },
    getErrors (fieldName) {
      if (fieldName in this.errors) {
        return this.errors[fieldName]
      }
      return []
    },
    getWrapperAttrs (fieldName) {
      if (this.fieldConfigs && (fieldName in this.fieldConfigs)) {
        return this.fieldConfigs[fieldName].flexAttrs || {}
      }
      return {}
    }
  },
  watch: {
    data () {
      this.$emit('input', this.data)
    },
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.data = this.value
        }
      }
    },
    touch () {
      if (this.value) {
        this.data = this.value
      }
    },
    valid () {
      this.$emit('valid', this.valid)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ObjectForm.vue?bf9cda50